module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mt-5": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "xs12": "",
      "md12": "",
      "lg8": "",
      "pa-0": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-center font-24 fw-700",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_vm._v("\r\n                                " + _vm._s(_vm.$t("enableAuthentication.title")) + "\r\n                            ")])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "font-16",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('span', {
    staticClass: "fw-400 primary--text"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step1")) + "\r\n                                ")]), _vm._v(" "), _c('span', [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step1Msg")) + "\r\n                                ")])])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "ml-5",
    attrs: {
      "xs4": "",
      "lg2": ""
    }
  }, [_c('div', {
    staticClass: "google-authentication-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/google_authenticator.jpg")
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "lg10": ""
    }
  }, [_c('div', {
    staticClass: "links"
  }, [_c('p', [_vm._v("\r\n                                        IOS "), _c('a', {
    staticClass: "primary--text",
    attrs: {
      "href": "https://itunes.apple.com/cn/app/google-authenticator/id388497605",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("enableAuthentication.download")))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                        Android "), _c('a', {
    staticClass: "primary--text",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("enableAuthentication.download")))])])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "font-16",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('span', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("\r\n                                   " + _vm._s(_vm.$t("enableAuthentication.step2")) + " \r\n                                ")]), _vm._v(" "), _c('span', [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step2Msg")) + "\r\n                                ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-5",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "160px",
      "height": "160px;"
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "font-16",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('span', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("\r\n                                   " + _vm._s(_vm.$t("enableAuthentication.step3")) + " \r\n                                ")]), _vm._v(" "), _c('span', [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step3Msg")) + "\r\n                                ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "authentication-secret-key primary--text ml-5"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.formCustom.authenticationSecret) + "   \r\n                                    "), _c('Icon', {
    staticClass: "secretKey",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "ios-copy-outline",
      "size": "20",
      "title": "Copy",
      "data-clipboard-text": this.formCustom.authenticationSecret,
      "color": "#41B8BC"
    },
    on: {
      "click": _vm.copySecretKey
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "font-14 mt-3"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.restoreMsg")) + "\r\n                                ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "font-16",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('span', {
    staticClass: "fw-bold primary--text"
  }, [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step4")) + "\r\n                                ")]), _vm._v(" "), _c('span', [_vm._v("\r\n                                    " + _vm._s(_vm.$t("enableAuthentication.step4Msg")) + "\r\n                                ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": "",
      "lg12": ""
    }
  }, [_c('v-form', {
    ref: "formCustom",
    staticClass: "ml-5"
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "id": "enter-verify-code",
      "counter": 6,
      "rules": _vm.randomCodeRules,
      "single-line": "",
      "outline": ""
    },
    model: {
      value: (_vm.formCustom.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "randomCode", $$v)
      },
      expression: "formCustom.randomCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "medium": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.verityRandomCode('formCustom')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.verify")))])], 1), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formCustom.id),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "id", $$v)
      },
      expression: "formCustom.id"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formCustom.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.formCustom, "authenticationSecret", $$v)
      },
      expression: "formCustom.authenticationSecret"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-369e4ccd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/EnableAuthentication.vue
// module id = 429
// module chunks = 0